import React from 'react';


export default function CartCancelButton({onClick}){

	return <button className="btn btn-block btn-secondary" onClick={onClick}>Cancel</button>
}